module.exports = __webpack_public_path__ + "img/brand-pic1-04.6ee3ef53.png";